import { findArrayItemById } from '../utils/arrayUtil';
import { getCartItemPrice } from '../utils/business/prices';

const useReadCartItemSingleResource = (cartItem, cartResources, isTaxIncluded, singleResourceClients) => {
  const elementPrice = getCartItemPrice(cartItem, isTaxIncluded);
  const elementPriceWithoutPromo = cartItem.price_without_promo ? parseFloat(cartItem.price_without_promo) : elementPrice;
  const resource = findArrayItemById(cartItem.resource_id, cartResources);
  const resourceClient = resource.nominative ? findArrayItemById(cartItem.client_id, singleResourceClients) : null;

  return { resource, elementPrice, elementPriceWithoutPromo, resourceClient };
};

export default useReadCartItemSingleResource;
